<div class="p-4 border border-grey-300 rounded-lg bg-standardwhite w-full">
  <div class="flex items-center justify-between mb-4 flex-wrap gap-2">
    <h3 class="mb-0">Actions</h3>
    <div class="resolved-toggle">
      <span class="toggle-text">Show resolved</span>
      <p-toggleSwitch [(ngModel)]="showResolved"></p-toggleSwitch>
    </div>
  </div>

  @if (loading) {
    <p>Loading actions...</p>
  }

  @if (!loading && filteredActions.length === 0) {
    <p class="text-grey-500">No actions for this event.</p>
  }

  @if (!loading && filteredActions.length > 0) {
    <div class="flex flex-col gap-3">
      @for (a of pagedActions; track a) {
        <div class="border border-grey-300 rounded-md p-3 flex flex-col gap-1 bg-grey-50">
          <div class="flex justify-between items-start gap-2">
            <p class="font-semibold">{{a.ActionDescription}}</p>
            @if (a.ActionVariationID === 2 && a.AuditName) {
              <span class="audit-pill">{{a.AuditName}}</span>
            }
            <div class="flex flex-col items-end gap-1">
              @if (a.Resolved) {
                <span class="status-pill closed">Resolved</span>
                @if (a.ResolvedDate) {
                  <span class="text-xs text-grey-700">Resolved {{resolvedDate(a)}}</span>
                }
              }
              @if (!a.Resolved && isOverdue(a)) {
                <span class="status-pill overdue">Overdue</span>
              }
              @if (!a.Resolved && !isOverdue(a) && isDueToday(a)) {
                <span class="status-pill due">Due today</span>
              }
              @if (!a.Resolved && !isOverdue(a) && !isDueToday(a)) {
                <span class="status-pill open">Open</span>
              }
              @if (!a.Resolved) {
                <span class="text-xs text-grey-700">Due {{humanDate(a.ActionDeadline)}}</span>
              }
            </div>
          </div>
          <div class="assigned-row">
            <p class="text-sm text-grey-700 mb-0">
              <span class="label">Assigned to:</span>
              <span class="font-semibold assignee">{{a.AssignedTo}}</span>
            </p>
            <button class="btn-inverse btn-compact btn-small view-btn" (click)="open(a.ActionID)">
              <i class="pi pi-eye"></i>
              <span class="ml-1 view-btn">View</span>
            </button>
          </div>
        </div>
      }
    </div>
    @if (filteredActions.length > pageSize) {
      <div class="paginator-wrapper">
        <p-paginator
          [rows]="pageSize"
          [totalRecords]="filteredActions.length"
          [rowsPerPageOptions]="[5,10,20]"
          [pageLinkSize]="3"
          (onPageChange)="onPageChange($event)">
        </p-paginator>
      </div>
    }
  }
</div>
